import React from "react";
import { Link } from "react-router-dom";
import LegalPage from "@/components/LegalPage";

export default function Privacy() {
  return (
    <LegalPage title="Privacy Policy" description="Informativa sul trattamento dei dati personali ai sensi del GDPR 2016/679" testid="privacy-page">
      <p>HostMarket è un prodotto di <strong>Vita da Host</strong>, con sede legale a Genova (P.IVA 02903680995). Questa informativa descrive come raccogliamo e trattiamo i dati personali ai sensi del <strong>Regolamento UE 2016/679 (GDPR)</strong> e della normativa italiana (D.Lgs. 196/2003 e successive modifiche).</p>

      <h2>1. Titolare del trattamento</h2>
      <p>Vita da Host<br />Email: <a href="mailto:team@vitadahost.it">team@vitadahost.it</a><br />P.IVA: 02903680995 - Sede: Genova, Italia</p>

      <h2>2. Dati raccolti</h2>
      <ul>
        <li><strong>Dati di registrazione</strong>: email, nome, password (hashata).</li>
        <li><strong>Dati di annuncio</strong>: descrizione, foto, video, contatti che hai scelto di pubblicare (email, telefono, WhatsApp, sito).</li>
        <li><strong>Dati di fatturazione</strong>: nome, email, nazione (tramite Stripe, nostro responsabile del trattamento).</li>
        <li><strong>Dati di navigazione</strong>: indirizzo IP, user-agent, pagine visitate (log server, max 30 giorni).</li>
        <li><strong>Dati di engagement</strong>: numero visualizzazioni e click dei tuoi annunci (anonimi).</li>
      </ul>

      <h2>3. Finalità del trattamento</h2>
      <ul>
        <li>Erogare il servizio (pubblicazione annunci, contatti, pagamenti).</li>
        <li>Invio email transazionali (conferme, reminder scadenza abbonamento).</li>
        <li>Sicurezza: rate limiting, anti-bruteforce, prevenzione frodi.</li>
        <li>Obblighi legali (fatturazione elettronica, conservazione SDI).</li>
      </ul>

      <h2>4. Base giuridica</h2>
      <ul>
        <li><strong>Esecuzione del contratto</strong> (Art. 6.1.b GDPR) per tutti i trattamenti legati all'erogazione del servizio.</li>
        <li><strong>Obbligo legale</strong> (Art. 6.1.c) per fatturazione e conservazione fiscale.</li>
        <li><strong>Legittimo interesse</strong> (Art. 6.1.f) per sicurezza e prevenzione abuso.</li>
        <li><strong>Consenso</strong> (Art. 6.1.a) per cookie analitici opzionali (vedi <Link to="/cookie">Cookie Policy</Link>).</li>
      </ul>

      <h2>5. Responsabili del trattamento</h2>
      <ul>
        <li><strong>Stripe Payments Europe Ltd</strong> (Irlanda) — pagamenti, DPA pubblico.</li>
        <li><strong>Brevo (Sendinblue)</strong> (Francia) — invio email transazionali.</li>
        <li><strong>MongoDB Atlas</strong> (EU-region) — hosting database.</li>
        <li><strong>Emergent Cloud</strong> (EU-region) — hosting applicazione e object storage immagini.</li>
      </ul>

      <h2>6. Trasferimenti extra-UE</h2>
      <p>Nessun trasferimento extra-UE sistematico. Eventuali sub-responsabili operano con Standard Contractual Clauses (SCCs) approvate dalla Commissione Europea.</p>

      <h2>7. Conservazione dei dati</h2>
      <ul>
        <li>Account attivo: finché non richiedi cancellazione.</li>
        <li>Log di sicurezza: 30 giorni.</li>
        <li>Dati di fatturazione: 10 anni (obbligo fiscale italiano).</li>
        <li>Dati di annunci scaduti: 90 giorni dall'ultima attività, poi anonimizzati.</li>
      </ul>

      <h2>8. I tuoi diritti</h2>
      <p>Ai sensi degli Artt. 15-22 GDPR puoi richiedere:</p>
      <ul>
        <li><strong>Accesso</strong>: copia dei tuoi dati (export JSON dalla dashboard → Impostazioni).</li>
        <li><strong>Rettifica</strong>: correggere dati errati (in autonomia dalla dashboard).</li>
        <li><strong>Cancellazione</strong>: eliminare account + dati (pulsante "Elimina account" in Impostazioni).</li>
        <li><strong>Portabilità</strong>: ricevere i dati in formato strutturato.</li>
        <li><strong>Opposizione / limitazione</strong>: contattaci via email.</li>
        <li><strong>Reclamo</strong>: al Garante Privacy (<a href="https://www.garanteprivacy.it" target="_blank" rel="noreferrer">garanteprivacy.it</a>).</li>
      </ul>

      <h2>9. Sicurezza</h2>
      <p>Password salvate con bcrypt, trasporto HTTPS/TLS 1.3, backup cifrati, accessi amministrativi con JWT + rate limiting. Nessun dato carta transita dai nostri server (gestito direttamente da Stripe, standard PCI DSS).</p>

      <h2>10. Contatti</h2>
      <p>Per esercitare i tuoi diritti o per qualunque domanda scrivici a <a href="mailto:team@vitadahost.it">team@vitadahost.it</a>. Risposta garantita entro 30 giorni.</p>
    </LegalPage>
  );
}
